export default {
  getContractAttachment: (state) => state.contractAttachment,
};
